import React, { useState } from 'react';
import PassoverLanding from './PassoverLanding';

const PassoverGuard = ({ children }) => {
  // Check if this browser has been "unlocked" by the owner
  const [isUnlocked, setIsUnlocked] = useState(
    localStorage.getItem('emergency_unlocked') === 'true'
  );

  const handleUnlock = () => {
    const password = prompt("Emergency Staff Entry:");
    if (password === "Paradise2026") {
      localStorage.setItem('emergency_unlocked', 'true');
      setIsUnlocked(true);
    } else {
      alert("Access Denied");
    }
  };

  if (isUnlocked) {
    return (
      <>
        {/* Warning Bar so the owner knows they can still add orders */}
        <div className="bg-red-700 text-white text-center py-2 text-sm sticky top-0 z-[9999] no-print">
          ⚠️ EMERGENCY OVERRIDE ACTIVE: Online ordering is currently hidden from the public.
          <button onClick={() => { localStorage.removeItem('emergency_unlocked'); setIsUnlocked(false); }} className="ml-4 underline font-bold">Lock Site Now</button>
        </div>
        {children}
      </>
    );
  }

  // Otherwise, show the Happy Passover Message
  return <PassoverLanding onAdminBypass={handleUnlock} />;
};

export default PassoverGuard;